import { ScoresReport } from "./ScoresReport";
export default ScoresReport;
